'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require('../../util/common'),
  toQueryString = _require.toQueryString;
var _trim = require('lodash/trim');
Entry.AI_UTILIZE_BLOCK.tts = {
  name: 'tts',
  imageName: 'tts.svg',
  category: 'general',
  sponsorText: 'Powered by {image}',
  sponsorImage: 'naverClova.png',
  sponsorOnImage: 'naverClovaOn.png',
  title: {
    ko: '읽어주기',
    en: 'read',
    jp: 'を読み上げる'
  },
  titleKey: 'template.tts_title_text',
  description: Lang.Msgs.ai_utilize_tts_description,
  descriptionKey: 'Msgs.ai_utilize_tts_description',
  isInitialized: true,
  init: function init() {},
  api: '/api/expansionBlock/tts/read',
  sponsor: 'clovaNaver',
  sponsorLink: 'https://www.ncloud.com/product/aiService/css',
  loadQueue: []
};
Entry.AI_UTILIZE_BLOCK.tts.getBlocks = function () {
  var params = {
    getSpeaker: function getSpeaker() {
      var isPython = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var param = {
        type: 'Dropdown',
        options: [[Lang.Blocks.tts_female, 'kyuri'], [Lang.Blocks.tts_male, 'jinho'], [Lang.Blocks.tts_kind, 'hana'], [Lang.Blocks.tts_sweet, 'dinna'], [Lang.Blocks.tts_echo, 'brown'], [Lang.Blocks.tts_mischievous, 'minions'], [Lang.Blocks.tts_dainty, 'sally'], [Lang.Blocks.tts_sabina, 'nsabina'], [Lang.Blocks.tts_mammon, 'nmammon'], [Lang.Blocks.tts_kitty, 'nmeow'], [Lang.Blocks.tts_doggy, 'nwoof']],
        value: 'kyuri',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
      if (isPython) {
        param.converter = Entry.block.converters.returnStringValue;
      }
      return param;
    },
    getSpeed: function getSpeed() {
      var isPython = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var param = {
        type: 'Dropdown',
        options: [[Lang.Blocks.tts_veryslow, '5'], [Lang.Blocks.tts_slow, '3'], [Lang.Blocks.tts_normal, '0'], [Lang.Blocks.tts_fast, '-3'], [Lang.Blocks.tts_veryfast, '-5']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
      if (isPython) {
        param.converter = Entry.block.converters.returnStringValue;
      }
      return param;
    },
    getPitch: function getPitch() {
      var isPython = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var param = {
        type: 'Dropdown',
        options: [[Lang.Blocks.tts_verylow, '5'], [Lang.Blocks.tts_low, '3'], [Lang.Blocks.tts_normal, '0'], [Lang.Blocks.tts_high, '-3'], [Lang.Blocks.tts_veryhigh, '-5']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
      if (isPython) {
        param.converter = Entry.block.converters.returnStringValue;
      }
      return param;
    }
  };
  var hashCode = function hashCode(s) {
    return s.split('').reduce(function (a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  };
  var checkText = function checkText(text) {
    var result = {
      result: false,
      message: Lang.Blocks.unknown_sentence
    };
    if (!text) {
      result.message = Lang.Blocks.no_sentence;
      return result;
    }
    if (text.length > 2500) {
      result.message = Lang.Blocks.sentence_over_2500_charactor;
      return result;
    }
    return {
      result: true,
      message: _trim(text),
      hash: hashCode(text + new Date().getTime())
    };
  };

  /**
   * wodnjs6512: 로드를 새로 할때는 queue를 다시 만든다고 하네요
   * 기존 코드에서 하나의 로더로 로드를 2개를 콜하면 하나는 정상 로드가 되지 않는 이슈가 있다고 합니다
   * 한번에 로드가 가능하도록 매번 로더를 따로 만들어서 사용하도록 수정
   * https://github.com/CreateJS/PreloadJS/issues/232#issuecomment-338739115
   *  */
  var read = function read(args) {
    return new Promise(function (resolve) {
      var message = args.message,
        hash = args.hash,
        prop = args.prop;
      var tts = Entry.AI_UTILIZE_BLOCK.tts;
      var id = "tts-".concat(hash, "-").concat(JSON.stringify(prop));
      var type = createjs.LoadQueue.SOUND;
      var soundQueue = new createjs.LoadQueue(true);
      soundQueue.installPlugin(createjs.Sound);
      soundQueue.maintainScriptOrder = true;
      var src = "".concat(Entry.baseUrl).concat(Entry.AI_UTILIZE_BLOCK.tts.api, ".mp3?").concat(toQueryString(_objectSpread({
        text: message
      }, prop)));
      var loadHandler = function loadHandler(_ref) {
        var currentTarget = _ref.currentTarget;
        var items = currentTarget.getItems().map(function (_ref2) {
          var item = _ref2.item;
          return item;
        });
        tts.loadQueue = tts.loadQueue.filter(function (id) {
          var filtered = items.find(function (item) {
            return item.id === id;
          });
          if (filtered) {
            var instance = Entry.Utils.playSound(id, filtered.prop);
            instance.soundType = 'tts';
            Entry.Utils.addSoundInstances(instance);
            var duration = instance.duration > 0 ? instance.duration : filtered.duration * 300;
            setTimeout(function () {
              resolve();
            }, duration);
          }
          return true;
        });
      };
      // 읽어주기 오류 발생 시, 다음 블록 실행
      var _errorHandler = /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                soundQueue.removeEventListener('complete', loadHandler);
                soundQueue.removeEventListener('error', _errorHandler);
                soundQueue.destroy();
                resolve();
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function errorHandler() {
          return _ref3.apply(this, arguments);
        };
      }();
      soundQueue.on('complete', loadHandler);
      soundQueue.on('error', _errorHandler);
      soundQueue.loadFile({
        id: id,
        src: src,
        type: type,
        prop: prop,
        duration: message.length
      });
      tts.loadQueue.push(id);
    });
  };
  return {
    tts_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.template.tts_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'tts_title'
      },
      "class": 'tts',
      isNotFor: ['tts'],
      events: {}
    },
    read_text: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string'
      }, {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {},
      def: {
        params: [{
          type: 'text',
          params: [Lang.Blocks.entry]
        }, null],
        type: 'read_text'
      },
      pyHelpDef: {
        params: ['A&value'],
        type: 'read_text'
      },
      paramsKeyMap: {
        TEXT: 0
      },
      "class": 'tts',
      isNotFor: ['tts'],
      func: function func(sprite, script) {
        var _checkText = checkText(script.getStringValue('TEXT', script)),
          result = _checkText.result,
          message = _checkText.message,
          hash = _checkText.hash;
        if (result) {
          var prop = sprite.getVoiceProp();
          read({
            message: message,
            hash: hash,
            prop: prop
          });
        }
        return script.callReturn();
      },
      syntax: {
        js: [],
        py: [{
          syntax: 'TTS.read(%1)',
          blockType: 'param',
          textParams: [{
            type: 'Block',
            accept: 'string'
          }]
        }]
      },
      wikiClass: 'ai_utilize_tts'
    },
    read_text_wait_with_block: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string'
      }, {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {},
      def: {
        params: [{
          type: 'text',
          params: [Lang.Blocks.entry]
        }, null],
        type: 'read_text_wait_with_block'
      },
      pyHelpDef: {
        params: ['A&value'],
        type: 'read_text_wait_with_block'
      },
      paramsKeyMap: {
        TEXT: 0
      },
      "class": 'tts',
      isNotFor: ['tts'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var _checkText2, result, message, hash, prop;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _checkText2 = checkText(script.getStringValue('TEXT', script)), result = _checkText2.result, message = _checkText2.message, hash = _checkText2.hash;
                prop = sprite.getVoiceProp();
                if (!result) {
                  _context2.next = 2;
                  break;
                }
                _context2.next = 1;
                return read({
                  message: message,
                  hash: hash,
                  prop: prop
                });
              case 1:
                return _context2.abrupt("return", script.callReturn());
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      syntax: {
        js: [],
        py: [{
          passTest: true,
          syntax: 'TTS.read_and_wait(%1)'
        }]
      },
      wikiClass: 'ai_utilize_tts'
    },
    set_tts_property: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getSpeaker(), params.getSpeed(), params.getPitch(), {
        type: 'Indicator',
        img: 'block_icon/ai_utilize_icon.svg',
        size: 11
      }],
      events: {},
      def: {
        params: [params.getSpeaker().value, params.getSpeed().value, params.getPitch().value, null],
        type: 'set_tts_property'
      },
      pyHelpDef: {
        params: ['A&value', 'B&value', 'C&value'],
        type: 'set_tts_property'
      },
      paramsKeyMap: {
        SPEAKER: 0,
        SPEED: 1,
        PITCH: 2
      },
      "class": 'tts',
      isNotFor: ['tts'],
      func: function func(sprite, script) {
        var speaker = script.getField('SPEAKER', script);
        var speed = script.getField('SPEED', script);
        var pitch = script.getField('PITCH', script);
        var volume = 1;
        sprite.setVoiceProp({
          speaker: speaker,
          speed: speed,
          pitch: pitch,
          volume: volume
        });
        return script.callReturn();
      },
      syntax: {
        js: [],
        py: [{
          syntax: 'TTS.set(%1, %2, %3)',
          blockType: 'param',
          textParams: [params.getSpeaker(true), params.getSpeed(true), params.getPitch(true)]
        }]
      },
      wikiClass: 'ai_utilize_tts'
    }
  };
};